/**
 * @class AppConfig
 */
class AppConfig {
  constructor() {
    this._settings = {};
  }

  /**
   * Set application settings
   * @param {Object} settings - The settings object
   */
  set(settings) {
    this._settings = settings;
  }

  /**
   * Get application settings
   * @returns {import("../../../types/configuration-app").IConfigurationSetting}
   */
  get() {
    return this._settings;
  }
}

// Create and export a singleton instance
export default new AppConfig();